import React, { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class IntegrationWorkflow  extends Component {

    

    render() {

        // var userToken = localStorage.getItem('token');
        // if(! userToken) {
        //       return <Navigate  to='/login' replace="true" />
        //   }

          var example = JSON.stringify({
                "success": false,
                "message": "Invalid Session"
            }, null, 2)

        const copyClipboard = (e,data) => {
            console.log('copyClipboard');
            e.preventDefault();
            navigator.clipboard.writeText(data);
            toast.success('Data copied !', {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            });
        };

        return (
            <div>
                <div class="docs-content">
                    <div class="container">
                    <article class="docs-article" id="section-1">
                        <h1 class="docs-heading">
                            Integration Workflow
                        </h1>

                        <section class="docs-intro">
                            <p>
                                The remittance APIs must be called in the sequence shown below.
                                Each step depends on the successful completion of the previous
                                step, and all required data (such as <code>session_id</code>,
                                <code>locationId</code>, and transaction values) must be preserved
                                throughout the transaction lifecycle.
                            </p>
                        </section>
                    </article>

                    <article class="docs-article">
                        <section class="docs-section">

                            <h2 class="section-heading">
                                Integration Workflow
                            </h2>

                            <table class="table table-bordered table-white">
                                <thead>
                                    <tr>
                                        <th>Step</th>
                                        <th>Action</th>
                                        <th>Notes</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>Get Remittance Countries</td>
                                        <td>Populate destination country list.</td>
                                    </tr>

                                    <tr>
                                        <td>2</td>
                                        <td>Select Destination Country</td>
                                        <td>User selects the target country.</td>
                                    </tr>

                                    <tr>
                                        <td>3</td>
                                        <td>Get Available Corridors</td>
                                        <td>Returns <code>session_id</code> — store immediately.</td>
                                    </tr>

                                    <tr>
                                        <td>4</td>
                                        <td>Save session_id</td>
                                        <td>Reuse across all subsequent APIs.</td>
                                    </tr>

                                    <tr>
                                        <td>5</td>
                                        <td>Calculate Exchange Rates</td>
                                        <td>Treat as a quote — do not modify returned values.</td>
                                    </tr>

                                    <tr>
                                        <td>6</td>
                                        <td>Get Payout List</td>
                                        <td>Required if <code>isPayoutRequired = true</code>.</td>
                                    </tr>

                                    <tr>
                                        <td>7</td>
                                        <td>Select Payout Institution</td>
                                        <td>Store <code>locationId</code> for downstream APIs.</td>
                                    </tr>

                                    <tr>
                                        <td>8</td>
                                        <td>Get Recipient Form</td>
                                        <td>Render all beneficiary fields dynamically.</td>
                                    </tr>

                                    <tr>
                                        <td>9</td>
                                        <td>Get Branch Codes</td>
                                        <td>Only when branch selection is required.</td>
                                    </tr>

                                    <tr>
                                        <td>10</td>
                                        <td>Collect Beneficiary Information</td>
                                        <td>Validate according to API response rules.</td>
                                    </tr>

                                    <tr>
                                        <td>11</td>
                                        <td>Submit Make Payment Request</td>
                                        <td>Submit the complete transaction.</td>
                                    </tr>

                                    <tr>
                                        <td>12</td>
                                        <td>Store Transaction ID</td>
                                        <td>Required for tracking and reconciliation.</td>
                                    </tr>

                                    <tr>
                                        <td>13</td>
                                        <td>Get Transaction Detail</td>
                                        <td>Retrieve the latest transaction status.</td>
                                    </tr>

                                    <tr>
                                        <td>14</td>
                                        <td>Reconcile Transaction Status</td>
                                        <td>Match transaction status against internal records.</td>
                                    </tr>

                                </tbody>
                            </table>

                        </section>
                    </article>

                    <article class="docs-article">
                        <section class="docs-section">

                            <h2 class="section-heading">
                                Session Management
                            </h2>

                            <p>
                                The <code>session_id</code> returned by the
                                <b> Get Available Corridors </b> API must be stored
                                immediately and reused across all subsequent APIs for the same
                                transaction.
                            </p>

                        </section>
                    </article>

                    <article class="docs-article">
                        <section class="docs-section">

                            <h2 class="section-heading">
                                Session ID Required Conditions
                            </h2>

                            <table class="table table-bordered table-white">
                                <thead>
                                    <tr>
                                        <th>API</th>
                                        <th>Session ID Required</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>Calculate Exchange Rates</td>
                                        <td>Yes</td>
                                    </tr>

                                    <tr>
                                        <td>Get Payout List</td>
                                        <td>Yes</td>
                                    </tr>

                                    <tr>
                                        <td>Get Recipient Form</td>
                                        <td>Yes</td>
                                    </tr>

                                    <tr>
                                        <td>Get Branch Codes</td>
                                        <td>Yes</td>
                                    </tr>

                                    <tr>
                                        <td>Make Payment</td>
                                        <td>Yes</td>
                                    </tr>

                                </tbody>
                            </table>

                        </section>
                    </article>

                    <article class="docs-article">
                        <section class="docs-section">

                            <h2 class="section-heading">
                                Business Rules
                            </h2>

                            <table class="table table-bordered table-white">
                                <thead>
                                    <tr>
                                        <th>Rule</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>Session Reuse</td>
                                        <td>Use the same <code>session_id</code> throughout the transaction.</td>
                                    </tr>

                                    <tr>
                                        <td>New Transaction</td>
                                        <td>Every new transaction requires a new <code>session_id</code>.</td>
                                    </tr>

                                    <tr>
                                        <td>Invalid Session</td>
                                        <td>Requests containing an invalid <code>session_id</code> may be rejected.</td>
                                    </tr>

                                    <tr>
                                        <td>Session Completion</td>
                                        <td>After a successful Make Payment request, the <code>session_id</code> becomes invalid.</td>
                                    </tr>

                                </tbody>
                            </table>

                        </section>
                    </article>

                    <article class="docs-article">
                        <section class="docs-section">

                            <h2 class="section-heading">
                                Error Response
                            </h2>

                            <pre>
                                <code class="copybox-code">
                    {example}
                                </code>
                            </pre>

                        </section>
                    </article>

                        <article class="docs-article" id="section-3">
                            <section class="docs-section row" id="item-3-1">
                                <div class="col-12">
                                    <nav aria-label="Page navigation example">
                                        <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                to="/merchant-integration-notes"
                                                tabIndex="-1"
                                                aria-disabled="true"
                                            >
                                                <i class="bi bi-arrow-left"></i>&nbsp;
                                                Integration Notes
                                            </Link>
                                        </li>

                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                 to="/merchant-dependency-matrix"
                                            >
                                                Dependency Matrix&nbsp;
                                                <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                        </ul>
                                    </nav>
                                </div>

                            </section>

                        </article>

                    </div>
                </div>
                <ToastContainer closeOnClick autoClose={2000}></ToastContainer>
            </div >
        )
    }

}